"use client"

import DashboardLayout from "@/views/dashboard/DashboardLayout"
import Earnings from "./Earnings"

export default function EarningsPage() {
  return (
    <DashboardLayout>
      <Earnings />
    </DashboardLayout>
  )
}
